import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import BasicCombo from '../../Components/Combo_Basic';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import agCheckbox from '../../Components/agGrid/ag-Checkbox';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function Bm10030(props) {
    const [checkToggle, setCheckToggle] = React.useState(false);
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    //왼쪽 그리드 컬럼
    const columnDefs = [
        {
            field: 'authGroupCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_AuthGroupCd' && f.lanType === 'COL')[0].lanName
                    : '', //그룹권한
            minWidth: 150,
            editable: false,
        },
        {
            field: 'authGroupNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_AuthGroupNm' && f.lanType === 'COL')[0].lanName
                    : '', //그룹권한명
            minWidth: 200,
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            editable: false,
        },
    ];
    //오른쪽그리드
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'authGroupCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_AuthGroupCd' && f.lanType === 'COL')[0].lanName
                    : '', //그룹권한
            minWidth: 150,
            editable: false,
        },
        {
            field: 'lcategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '', //대분류
            minWidth: 200,
            editable: false,
        },
        {
            field: 'mcategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '', //중분류
            minWidth: 150,
            editable: false,
        },
        {
            field: 'scategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Scategory' && f.lanType === 'COL')[0].lanName
                    : '', //소분류
            minWidth: 150,
            editable: false,
        },
        {
            field: 'detailCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DetailCd' && f.lanType === 'COL')[0].lanName
                    : '', //상세권한
            minWidth: 150,
            editable: false,
        },
        {
            field: 'detailNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DetailNm' && f.lanType === 'COL')[0].lanName
                    : '', //상세권한참조
            minWidth: 150,
            editable: false,
        },
        {
            field: 'screenType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ScreenType' && f.lanType === 'COL')[0].lanName
                    : '', //화면분류
            minWidth: 150,
        },
        {
            field: 'createYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateYn' && f.lanType === 'COL')[0].lanName
                    : '', //추가권한
            minWidth: 150,
            cellRenderer: (e) => {
                return agCheckbox(e);
                // if (e.value === "X") {
                //   return "X";
                // } else {
                //   return agCheckbox(e);
                // }
            },
            editable: false,
        },
        {
            field: 'readYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ReadYn' && f.lanType === 'COL')[0].lanName
                    : '', //조회권한
            minWidth: 150,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return 'X';
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'updateYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateYn' && f.lanType === 'COL')[0].lanName
                    : '', //저장권한
            minWidth: 150,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return 'X';
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'deleteYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DeleteYn' && f.lanType === 'COL')[0].lanName
                    : '', //삭제권한
            minWidth: 150,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return 'X';
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'printYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PrintYn' && f.lanType === 'COL')[0].lanName
                    : '', //인쇄권한
            minWidth: 150,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return 'X';
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        // {
        //   field: "excelYn",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ExcelYn" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //EXCEL권한
        //   minWidth: 150,
        //   cellRenderer: (e) => {
        //     if (e.value === "X") {
        //       return "X";
        //     } else {
        //       return agCheckbox(e);
        //     }
        //   },
        //   editable: false,
        // },
        // {
        //   field: "pdfYn",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_PDAYn" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //PDF권한
        //   minWidth: 150,
        //   cellRenderer: (e) => {
        //     if (e.value === "X") {
        //       return null;
        //     } else {
        //       return agCheckbox(e);
        //     }
        //   },
        //   editable: false,
        // },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
    ];

    React.useEffect(() => {
        document.title = '권한관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>권한관리</strong>" +
            '</h1>';
        if (props.inputs.checkingResult) {
            gridRef.current.api.setRowData([
                {
                    authGroupCd: props.inputs.checkingValue,
                },
                ...props.rowData,
            ]);
            props.setInputs({
                ...props.inputs,
                checkingValue: '',
                checkingResult: false,
            });
            props.setSaveGroups([
                {
                    authGroupCd: props.inputs.checkingValue,
                },
            ]);
        }
    }, [props.inputs.checkingResult]);

    return (
        <div className="card">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <div style={{ width: '30%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 왼쪽 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10030"
                            target="G01"
                            refreshFunc={() => props.Init()}
                            selectFunc={() => props.Init()}
                            addFunc={
                                () => setCheckToggle(true)
                                // gridRef.current.api.setRowData([
                                // 	{},
                                // 	...props.rowData,
                                // ])
                            }
                            saveFunc={() => props.SaveConfirm('grid')}
                            deleteFunc={() => props.DeleteConfirm('grid')}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 왼쪽 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: true,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, (_selected) => {
                                    if (_selected[0].authGroupCd) {
                                        props.setSelectedRowData(_selected);
                                        props.AuthGroupCodeSearch(_selected[0].authGroupCd);
                                    } else {
                                        props.setRowData1([]);
                                    }
                                })
                            }
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
                <div style={{ width: '69%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            {/* 권한 콤보 */}
                            <BasicCombo
                                combos={props.comboList}
                                value={props.inputs.comboValue}
                                onChange={(e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        comboValue: e,
                                    });
                                }}
                            />
                            {/* 복사 버튼  */}
                            <BasicButton
                                name={
                                    props.lanData.length > 0
                                        ? props.lanData.filter((f) => f.lanId === 'Btn_Copy' && f.lanType === 'BTN')[0]
                                              .lanName
                                        : ''
                                }
                                onClick={() => props.CopyLogic()}
                            />
                        </div>
                        {/* 두번째 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10030"
                            target="G02"
                            refreshFunc={() => props.AuthGroupCodeSearch(props.selectedRowData[0].authGroupCd)}
                            addFunc={() => {
                                if (props.selectedRowData.length > 0) {
                                    props.setGridTggle(true);
                                } else {
                                    return null;
                                }
                            }}
                            saveFunc={() => props.SaveConfirm('grid1')}
                            deleteFunc={() => props.DeleteConfirm('grid1')}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 두번째 그리드  */}
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: true,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)
                            }
                            // suppressRowClickSelection={true}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef1, props.setChangedRowData1)
                            }
                            groupDefaultExpanded={1}
                            suppressAggFuncInHeader={true}
                            enableCellChangeFlash={true}
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
            </div>
            {/* 그룹 권한 팝업 */}
            {checkToggle && (
                <BasicModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Col_AuthGroupCd' && f.lanType === 'COL')[0]
                                  .lanName
                            : '' //그룹권한
                    }
                    onClose={() => setCheckToggle(false)}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                            : '' //검사
                    }
                    execLogic={(e) => props.CheckingAuthGroup()}
                >
                    <Checking
                        datas={[
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Col_AuthGroupCd' && f.lanType === 'COL'
                                          )[0].lanName
                                        : '',
                                value: props.inputs.checkingValue,
                                onChange: (e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        checkingValue: e.target.value,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
            {props.gridToggle && (
                <GridModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_Group Menu Settings' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : ''
                    }
                    onClose={() => props.setGridTggle(false)}
                    gridColumn={props.menuGridColumnDef}
                    gridRowData={props.menuRowData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        props.setSelectedMenuRows(e);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        let pushData = [];
                        for (let i = 0; i < props.selectedMenuRows.length; i++) {
                            pushData.push({
                                authGroupCd: props.selectedRowData[0].authGroupCd,
                                lcategoCd: props.selectedMenuRows[i].lcategoCd,
                                mcategoCd: props.selectedMenuRows[i].mcategoCd,
                                scategoCd: props.selectedMenuRows[i].scategoCd,
                                detailCd: props.selectedMenuRows[i].detailCd,
                                createYn: props.selectedMenuRows[i].createYn,
                                readYn: props.selectedMenuRows[i].readYn,
                                updateYn: props.selectedMenuRows[i].updateYn,
                                deleteYn: props.selectedMenuRows[i].deleteYn,
                                printYn: props.selectedMenuRows[i].printYn,
                                excelYn: props.selectedMenuRows[i].excelYn,
                                pdfYn: props.selectedMenuRows[i].pdfYn,
                                screenType:
                                    props.selectedMenuRows[i].mcategoCd == 'BM10000' ||
                                    props.selectedMenuRows[i].mcategoCd == 'SM10000' ||
                                    props.selectedMenuRows[i].mcategoCd == 'PM10000' ||
                                    props.selectedMenuRows[i].mcategoCd == 'ST10000' ||
                                    props.selectedMenuRows[i].mcategoCd == 'MM10000' ||
                                    props.selectedMenuRows[i].mcategoCd == 'DB10000'
                                        ? 'L'
                                        : 'M',
                            });
                        }
                        gridRef1.current.api.setRowData([...pushData, ...props.rowData1]);
                        props.setChangedRowData1((current) => [...pushData, ...current]);
                    }}
                />
            )}
        </div>
    );
}

export default Bm10030;
